<app-header></app-header>

<main class="site-main">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
